import { Bar } from 'react-chartjs-2';
import './InboundGraph.scss'

const data = {
  labels: ['1', '2', '3', '4', '5', '6'],
  datasets: [
    {
      label: '# of Red Votes',
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: '#00BA88',
    },
    {
      label: '# of Blue Votes',
      data: [2, 3, 20, 5, 1, 4],
      backgroundColor: '#00BA88',
    },
    {
      label: '# of Green Votes',
      data: [3, 10, 13, 15, 22, 20],
      backgroundColor: '#00BA88',
    },
  ],
};

const options = {
  indexAxis: 'x', // Si cambia a x se coloca en Vertical
  elements: {
    bar: {
      borderWidth: 2,
    },
  },

  responsive: true,

  plugins: {
    legend: {
      display: false,
      position: 'right', // legend de la gráfica (Opcional pasar display a true)
    },
    title: {
      display: false,
      text: 'Aqui va el titulo de la gráfica (Opcional pasar display a true)',
    },
  }

};

const InboundGraph = () => (
  <div className="inboundGraph s-cross-end">
    <Bar data={data} height={200} options={options} />
  </div>
);

export default InboundGraph
